import { DTO, IDTO } from "./dto";
import { Nilable } from "@shared/utils";

interface IDatosErrorDTO {
    id: number;
    message: string;
    country: string;
    errors: { code: number }[];
}

export interface ICanjeErrorDTO extends IDTO {
    error: IDatosErrorDTO;
}

export class CanjeErrorDTO implements DTO {
    public id = 0;
    public message = "";
    public pais = "";
    public errores: { code: number }[] = [];

    constructor(json: Nilable<Partial<ICanjeErrorDTO>> = null) {
        if (json?.error != null) {
            this.cargarDTO(json.error);
        }
    }

    public cargarDTO(json: Partial<IDatosErrorDTO>): void {
        if (json.id != null) {
            this.id = json.id;
        }
        if (json.message != null) {
            this.message = json.message;
        }
        if (json.country != null) {
            this.pais = json.country;
        }
        if (json.errors != null) {
            this.errores = json.errors;
        }
    }

    public toJSON(): ICanjeErrorDTO {
        return {
            error: {
                id: this.id,
                message: this.message,
                country: this.pais,
                errors: this.errores
            }
        };
    }
}
